import { css } from "@emotion/react";
import { createStyles } from "@mantine/core";

import { Z_INDEX } from "styles/theme";

export const useStyles = createStyles((theme) => ({
  toolbar: {
    position: "sticky",
    top: "55px",
    padding: "8px 16px",
    borderRadius: `${theme.radius.sm}px ${theme.radius.sm}px 0 0`,
    borderBottom: `1px solid ${theme.colors.divider[0]}`,
    background: theme.colors.baseBackground[0],
    zIndex: Z_INDEX.editorToolbar,
  },
  menuRightIcon: {
    width: "8px",
    height: "8px",
    padding: "4px",
  },
}));

export const leftBar = css`
  display: flex;
  gap: 32px;
`;

export const pluginGroup = css`
  display: flex;
  gap: 6px;
`;

export const rightBar = css`
  display: flex;
  gap: 12px;
  align-items: center;
`;
